







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import MemberExpel from '@/views/member/MemberExpel.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
    MemberExpel
  }
})
export default class WithdrawalMemberIframe extends Vue {

  private get remoteSrc() {
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/member/basic/withdrawal?serviceType=PREMIUM';

    return src;
  }
}
